













































import Vue from "vue";
import { CardColorTypes } from "../store/enums";
import { CardColors } from "../store/model";
export default Vue.extend({
  props: ["selected"],
  data: () => ({
    open: false,
    colors: {
      Default: "none",
      Red: "red accent-1",
      Orange: "orange accent-2",
      Yellow: "yellow accent-1",
      Green: "light-green accent-1",
      Blue: "cyan lighten-4",
      Purple: "purple lighten-4",
      Pink: "pink lighten-4",
    },
  }),
  methods: {
    colorSelected(color: CardColors) {
      this.$emit("color-selected", color);
    },
    selectedIcon(color: string, blank: boolean): string {
      const defaultIcon = blank
        ? "mdi-checkbox-blank-circle-outline"
        : "mdi-checkbox-blank-circle";
      const checkedIcon = blank
        ? "mdi-check-circle-outline"
        : "mdi-checkbox-marked-circle";
      return this.selected === color ? checkedIcon : defaultIcon;
    },
  },
  watch: {
    open: function(value: boolean): void {
      this.$store.dispatch("global/setColorMenuOpen", value);
    },
  },
});
